module.exports = __webpack_public_path__ + "img/img_head.eb77c0cf.png";